<template>
  <VanPopup
    v-model="show"
    round
    safe-area-inset-bottom
    position="bottom"
    overlay-class="custom-van-popup-overlay"
    class="custom-van-popup"
    @close="onCancel"
  >
    <slot></slot>
  </VanPopup>
</template>

<script>
export default {
  name: "CashCardPopup",
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    onCancel() {
      this.$emit("change", false);
    },
  },
};
</script>
